export const langText: any = {
    us: {
        copy_text: 'Copy Code',
        success_tips: 'Copied successfully',
    },
};
